import React, { useState, useEffect, useRef } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import BibleChapter from "./components/BibleChapter";
import StrongDetail from "./components/StrongDetail";
import ChapterSelector from "./components/ChapterSelector";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from "@mui/icons-material/LightMode";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
	return (
		<Router>
		  <Routes>
			<Route path="/" element={<BibleChapterPage />} />
			<Route path="/strongs/:strongCode" element={<StrongDetail />} />
		  </Routes>
		</Router>
	  );
}


// Componente que obtiene el JSON del backend y pasa a BibleChapter
function BibleChapterPage() {
  // Inicializar book y chapter desde localStorage si ambos existen; si no, usar 1 y 1
  const [book, setBook] = useState(() => {
    try {
      const sBook = localStorage.getItem("chapterSelector.bookId");
      return sBook ? Number(sBook) : 1;
    } catch (e) {
      return 1;
    }
  });

  const [chapter, setChapter] = useState(() => {
    try {
      const sChapter = localStorage.getItem("chapterSelector.chapter");
      return sChapter ? Number(sChapter) : 1;
    } catch (e) {
      return 1;
    }
  });

  const [darkMode, setDarkMode] = useState(() => {
    try {
      const s = localStorage.getItem("app.darkMode");
      return s === "true";
    } catch (e) {
      return false;
    }
  });

  // Persistir la preferencia al cambiar
  useEffect(() => {
    try {
      localStorage.setItem("app.darkMode", darkMode ? "true" : "false");
    } catch (e) {
      // ignore
    }
  }, [darkMode]);

  // Versículo a resaltar tras pulsar "Ir" en la búsqueda: { verseNumber, nonce }.
  // El nonce fuerza que se vuelva a resaltar aunque se pida el mismo versículo.
  const [highlightVerse, setHighlightVerse] = useState(null);
  const highlightNonce = useRef(0);

  const handleSelect = (newBook, newChapter, verseNumber) => {
    setBook(newBook);
    setChapter(newChapter);

    const parsed = Number(verseNumber);
    setHighlightVerse(
      parsed > 0 ? { verseNumber: parsed, nonce: ++highlightNonce.current } : null
    );
  };

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  // Colores tipo papiro para el fondo en modo claro
  const papiroDefault = "#f5efdc"; // color de fondo general (papiro)
  const papiroPaper = "#faf8f2";   // color para superficies (paper)

  const theme = createTheme({
    palette: {
      mode: darkMode ? "dark" : "light",
      primary: {
        main: darkMode ? "#90caf9" : "#1976d2",
      },
      background: {
        default: darkMode ? "#121212" : papiroDefault,
        paper: darkMode ? "#1e1e1e" : papiroPaper,
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div style={{ margin: "2rem" }}>
        <header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <h1>📖 Lectura Bíblica</h1>

          <Tooltip title={darkMode ? "Modo claro" : "Modo oscuro"} arrow>
            <IconButton onClick={toggleDarkMode} color="inherit">
              {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
            </IconButton>
          </Tooltip>
        </header>

        <ChapterSelector onSelect={handleSelect} />
        <BibleChapter book={book} chapter={chapter} highlightVerse={highlightVerse} />
      </div>
    </ThemeProvider>
  );
}
  
export default App;
